import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import SnackbarContent from "@material-ui/core/SnackbarContent/SnackbarContent";
import Snackbar from "@material-ui/core/Snackbar/Snackbar";

const styles = theme => ({
  snackbarContentRoot: {
    backgroundColor: theme.palette.error.dark,
    maxWidth: "100%"
  }
});

const message =
  "The use of an ad blocker on this site will impair functionality; please disable.";

class OSSAdBlockChecker extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isDetected: false };
  }

  componentDidMount = () => {
    this.loadAdBlockerScript();
  }

  onAdBlockerLoad = () => {
    const adBlock = new FuckAdBlock({ checkOnLoad: true, resetOnEnd: true }); // eslint-disable-line no-undef
    adBlock.onDetected(this.adBlockDetected);
    adBlock.onNotDetected(this.adBlockNotDetected);
    return adBlock;
  };

  onAdBlockerLoadError = () => {
    this.setState({ isDetected: true });
  };

  loadAdBlockerScript = () => {
    const importFAB = document.createElement("script");

    importFAB.onload = this.onAdBlockerLoad;
    importFAB.onerror = this.onAdBlockerLoadError;

    importFAB.integrity = "sha256-4/8cdZfUJoNm8DLRzuKwvhusQbdUqVov+6bVj9ewL7U=";
    importFAB.crossOrigin = "anonymous";
    importFAB.src =
      "https://cdnjs.cloudflare.com/ajax/libs/fuckadblock/3.2.1/fuckadblock.js";
    document.head.appendChild(importFAB);

    return importFAB;
  };

  adBlockDetected = () => {
    this.setState({ isDetected: true });
  };

  adBlockNotDetected = () => {
    this.setState({ isDetected: false });
  };

  render() {
    const { classes } = this.props;
    const { isDetected } = this.state;

    if (isDetected) {
      return (
        <Snackbar open={true}>
          <SnackbarContent
            message={message}
            classes={{ root: classes.snackbarContentRoot }}
          />
        </Snackbar>
      );
    }

    return null;
  }
}

OSSAdBlockChecker.propTypes = {};
OSSAdBlockChecker.defaultProps = {};

export default withStyles(styles)(OSSAdBlockChecker);
